import React from "react";

export const ForMyClassroom = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3818 12.2622C13.9676 12.2622 13.6318 11.9264 13.6318 11.5122L13.6318 2.96371C13.6035 2.94793 13.5536 2.92978 13.4834 2.92978L2.70178 2.92978C2.63152 2.92978 2.58161 2.94793 2.55332 2.96371L2.55332 11.5122C2.55332 11.9264 2.21753 12.2622 1.80332 12.2622C1.3891 12.2622 1.05332 11.9264 1.05332 11.5122L1.05332 2.89766C1.05332 1.93869 1.95713 1.42978 2.70178 1.42978L13.4834 1.42978C14.228 1.42978 15.1318 1.93869 15.1318 2.89766L15.1318 11.5122C15.1318 11.9264 14.796 12.2622 14.3818 12.2622Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.04721 5.24829C7.2579 5.24829 6.64204 5.8727 6.64204 6.6136C6.64204 7.35451 7.2579 7.97892 8.04721 7.97892C8.83653 7.97892 9.45238 7.35451 9.45238 6.6136C9.45238 5.8727 8.83653 5.24829 8.04721 5.24829ZM5.14204 6.6136C5.14204 5.018 6.45599 3.74829 8.04721 3.74829C9.63843 3.74829 10.9524 5.018 10.9524 6.6136C10.9524 8.20921 9.63843 9.47892 8.04721 9.47892C6.45599 9.47892 5.14204 8.20921 5.14204 6.6136ZM5.57472 13.4294H10.5197C10.4056 12.2056 9.35383 11.2277 8.04721 11.2277C6.74059 11.2277 5.68885 12.2056 5.57472 13.4294ZM4.06445 13.6506C4.06445 11.4709 5.86085 9.72765 8.04721 9.72765C10.2336 9.72765 12.03 11.4709 12.03 13.6506V14.1794C12.03 14.5937 11.6942 14.9294 11.28 14.9294H4.81445C4.40024 14.9294 4.06445 14.5937 4.06445 14.1794V13.6506Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.90478 11.5204C9.90479 11.1062 10.2406 10.7704 10.6548 10.7704L15.4367 10.7706C15.8509 10.7706 16.1867 11.1064 16.1867 11.5206C16.1866 11.9348 15.8509 12.2706 15.4366 12.2706L10.6548 12.2704C10.2405 12.2704 9.90477 11.9346 9.90478 11.5204Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.15478 11.5551C0.15478 11.1409 0.490566 10.8051 0.90478 10.8051L5.59253 10.8051C6.00674 10.8051 5.76708 11.1817 5.76708 11.5959C5.76708 12.0101 5.32047 12.3051 4.90625 12.3051C4.49204 12.3051 0.90478 12.3051 0.90478 12.3051C0.490567 12.3051 0.15478 11.9693 0.15478 11.5551Z"
        fill="#666666"
      />
    </svg>
  );
};
